const _STARTER_FITCHER_CHART_INIT = {
  era: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    // location: 'home',
    visible: false
  },
  whip: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    // location: 'home',
    visible: false
  },
  hitAvg: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    // location: 'home',
    visible: false
  },
  so9: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    // location: 'home',
    visible: false
  },
  bb: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    // location: 'home',
    visible: false
  }
};

const _COMPARISON_CHART_INIT = {
  era: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    visible: false
  },
  ops: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    visible: false
  },
  avg: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    visible: false
  },
  hr: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    visible: false
  },
  sb: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    visible: false
  },
  whip: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    visible: false
  },
  err: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    visible: false
  }
};

const _SEPCIAL_CHART_INIT = {
  bob: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    visible: false
  },
  so: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    visible: false
  },
  hr: {
    home: {
      p: 0,
      v: ''
    },
    away: {
      p: 0,
      v: ''
    },
    visible: false
  }
};

export { _STARTER_FITCHER_CHART_INIT, _COMPARISON_CHART_INIT, _SEPCIAL_CHART_INIT };
